function BottomButtonArea(props:any){
   let myProps={
    Style:{},
    todo_info:{},
    on_click_back:()=>{},
    completeOne:()=>{},
    ...props
  };
  let Style=myProps.Style;
  let todo_info=myProps.todo_info;
  
  return (
    <div className={Style.bottom_btn_wrap}>
      <button className={Style.bottom_btn} onClick={myProps.on_click_back} >목록으로</button>
      {todo_info.a_is_success!="1"&&
        <button className={Style.bottom_btn} onClick={myProps.completeOne} style={{background:"#B9CA42"}}>완료하기</button>
      }
    </div>
  );
};
export default BottomButtonArea;